import SwiperComponent from './Swiper'
import SwiperItemComponent from './SwiperItem'

export const Swiper = SwiperComponent
export const SwiperItem = SwiperItemComponent
